package data.objects.views.directediting

import apiclient.customfields.parseFieldValues
import apiclient.geoobjects.GeoObjectDetails
import auth.CurrentWorkspaceStore
import data.objects.ActiveObjectStore
import dev.fritz2.core.RenderContext
import dev.fritz2.core.Store
import dev.fritz2.core.storeOf
import koin.withKoin
import kotlinx.coroutines.Job
import kotlinx.coroutines.flow.map
import localization.TL
import localization.translate
import model.L
import theme.FormationIcons
import twcomponents.twCardSectionTitle
import twcomponents.twEditTagsButton
import twcomponents.twIconSmall
import utils.extractReadOnlyTags
import utils.mergeTagLists
import utils.respectFeatureFlags
import utils.toKeyWordTagsList
import webcomponents.KeywordTagActionType
import webcomponents.KeywordTagType
import webcomponents.keywordTagList

fun RenderContext.tagsSection() {
    withKoin {
        val activeObjectStore: ActiveObjectStore = get()
        val currentWorkspaceStore: CurrentWorkspaceStore = get()

        val isEditable = activeObjectStore.current.editable()
        val keywordsSub = activeObjectStore.map(GeoObjectDetails.L.keywords)
        val readOnlyKeywordTags = activeObjectStore.map(GeoObjectDetails.L.tags).data.extractReadOnlyTags()
        val fieldValueTags = activeObjectStore.map(GeoObjectDetails.L.tags).data.respectFeatureFlags().map { tags ->
            currentWorkspaceStore.current?.fieldDefinitions?.let { definitions ->
                tags.parseFieldValues(definitions)
            }
        }.map { it?.toKeyWordTagsList(KeywordTagActionType.DefaultFieldValue) ?: emptyList() }

        div("-m-2 p-2") {
            // show tags of the object
            twCardSectionTitle {
                twIconSmall(FormationIcons.Tag)
                translate(TL.KeywordTags.CARD_TITLE)
            }

            div("max-h-full min-h-max mt-1 px-2") {
                keywordTagList(
                    keywords = mergeTagLists(
                        readOnlyTags = readOnlyKeywordTags,
                        keywords = keywordsSub.data,
                        fieldValueTags = fieldValueTags,
                    ),
                    searchable = true,
                    keywordTagType = KeywordTagType.ObjectTag,
                ) {
                    // if the user has edit rights -> model and button to trigger modal to edit tags
                    if (isEditable) {
                        // insert before all the keywords
                        twEditTagsButton {
                            +"Edit tags"
                            twIconSmall(icon = FormationIcons.Edit)

                            // modal store here
                            val tagManageModalToggleStore: Store<Boolean> = storeOf(false, Job())
                            // modal here
                            twTagManageModal(tagManageModalToggleStore)
                            clicks handledBy {
                                tagManageModalToggleStore.update(true)
                            }
                        }
                    }
                }
            }
        }

//        editingStore.data.render { isEditing ->
//            val newKeywordStore = storeOf("")
//            val suggestedTagsStore = storeOf<List<String>>(emptyList())
//
//            div("-m-2 p-2") {
//                if (isEditing) className("bg-gray-200")
//                div("mt-3 mb-1") {
//                    twRowOfJustifyBetween {
//                        twCardSectionTitle {
//                            twIconSmall(FormationIcons.Tag)
//                            translate(TL.KeywordTags.CARD_TITLE)
//                        }
//                        if (isEditable) {
//                            // show edit/close buttons
//                            val id = Random.nextULong().toString()
//                            div("static flex flex-row h-0 w-full pr-2 items-center justify-end") {
//                                div("relative flex flex-row w-max gap-5 py-2 px-4 rounded-xl shadow-xl", id = id) {
//                                    if (isEditing) {
//                                        if (domNode.classList.contains("hidden")) {
//                                            domNode.classList.remove("hidden")
//                                        }
//                                    } else domNode.classList.add("hidden")
//                                    fadeInFadeoutTransition()
//                                    if (editingStore.current) {
//                                        className("text-formationWhite bg-formationBlack")
//                                        twMediumIconButtonHighlight(icon = FormationUIIcons.Close) {
//                                            clicks.map { !editingStore.current } handledBy editingStore.update
//                                        }
//                                    } else {
//                                        className("bg-gray-300")
//                                        twMediumIconButtonNeutral(FormationIcons.Edit) {
//                                            clicks.map { !editingStore.current } handledBy editingStore.update
//                                        }
//                                    }
//                                }
//                            }
//                            if (!isEditing) {
//
//                                this@div.toggleClassOnElement(
//                                    className = "hidden",
//                                    elementId = id,
//                                )
//                            }
//                        }
//                    }
//                }
//                if (isEditing) {
//                    combine(tagsSub.data, keywordsSub.data) { t, k -> Pair(t, k) }.render { (tags, keywords) ->
//                        twColOf {
//                            val roTags = tags.extractReadOnlyTags().mapNotNull { it.readOnlyStringValue }
//
//                            val currentKeywords = keywords.orEmpty().toSet() - roTags.toSet()
//                            twRowOfWrap {
//                                currentKeywords.forEach { keyword ->
//                                    twTagButton(text = keyword, icon = FormationUIIcons.Close) {
//                                        clicks handledBy {
//                                            busyStore.handleApiCall(
//                                                supplier = {
//                                                    client.applyObjectChanges(ObjectChanges(objectId, RemoveKeywords(listOf(keyword))))
//                                                },
//                                                processResult = { geoObjects ->
//                                                    val updatedActiveObj = geoObjects.firstOrNull { it.id == objectId }
//                                                    updatedActiveObj?.let { updated ->
//                                                        keywordsSub.update(updated.keywords)
//                                                    }
//                                                },
//                                            )
//                                        }
//                                    }
//                                }
//                            }
//
//                            div("p-2") {
//                                inputLabelWrapper(
//                                    title = TL.KeywordTags.ADD_A_TAG_TOOLTIP,
//                                    visibilityFlow = newKeywordStore.data.map { it.isNotBlank() },
//                                ) {
//                                    twInputField(newKeywordStore) {
//                                        twInputTextField {
//                                            id("newKeywordInput")
//                                            placeholder(TL.KeywordTags.TAG_INPUT_PLACEHOLDER.getTranslationFlow())
//                                        }
//                                        twRightAlignedButtonRow {
//                                            newKeywordStore.data.render { newKw ->
//                                                if (newKw.isNotBlank()) {
//                                                    twRevertButton(newKeywordStore, "")
//                                                }
//                                            }
//                                        }
//                                    }
//                                }
//                            }
//
//                            newKeywordStore.data.debounce(150.milliseconds).render { enteredKeyword ->
//                                if (enteredKeyword.isNotBlank()) {
//                                    twRowOfWrap {
//                                        if (!currentKeywords.contains(enteredKeyword)) {
//                                            twTagButton(enteredKeyword, icon = FormationUIIcons.Add) {
//                                                clicks handledBy {
//                                                    busyStore.handleApiCall(
//                                                        supplier = {
//                                                            client.applyObjectChanges(ObjectChanges(objectId, AddKeywords(listOf(enteredKeyword))))
//                                                        },
//                                                        processResult = { geoObjects ->
//                                                            val updatedActiveObj = geoObjects.firstOrNull { it.id == objectId }
//                                                            updatedActiveObj?.let { updated ->
//                                                                keywordsSub.update(updated.keywords)
//                                                                insertInCaches(updated)
//                                                            }
//                                                        },
//                                                    )
//                                                }
//                                            }
//                                        }
//
//                                        CoroutineScope(job).launch {
//                                            val suggested = client.keywordsForQueryContext(
//                                                SearchQueryContext.newContext(listOf(currentWorkspaceStore.current?.groupId!!)),
//                                                enteredKeyword,
//                                                20,
//                                            ).getOrNull().orEmpty().filter { keyword ->
//                                                keyword != enteredKeyword && !currentKeywords.contains(keyword)
//                                            }
//                                            suggestedTagsStore.update(suggested)
//                                        }
//
//                                        suggestedTagsStore.data.render { suggestedKeywords ->
//                                            suggestedKeywords.forEach { suggestedKeyword ->
//                                                twTagButton(suggestedKeyword, icon = FormationUIIcons.Add) {
//                                                    clicks handledBy {
//                                                        busyStore.handleApiCall(
//                                                            supplier = {
//                                                                client.applyObjectChanges(
//                                                                    ObjectChanges(
//                                                                        objectId,
//                                                                        AddKeywords(listOf(suggestedKeyword)),
//                                                                    ),
//                                                                )
//                                                            },
//                                                            processResult = { geoObjects ->
//                                                                val updatedActiveObj = geoObjects.firstOrNull { it.id == objectId }
//                                                                updatedActiveObj?.let { updated ->
//                                                                    keywordsSub.update(updated.keywords)
//                                                                    insertInCaches(updated)
//                                                                }
//                                                            },
//                                                        )
//                                                    }
//                                                }
//                                            }
//                                        }
//                                    }
//                                }
//                            }
//                        }
//                    }
//                } else {
//                    div("max-h-full min-h-max mt-1 px-2") {
//                        keywordTagList(
//                            keywords = mergeTagLists(
//                                readOnlyTags = readOnlyKeywordTags,
//                                keywords = keywordsSub.data,
//                                fieldValueTags = fieldValueTags,
//                            ),
//                            searchable = true,
//                            keywordTagType = KeywordTagType.ObjectTag,
//                        )
//                    }
//                }
//            }
//        }
    }
}

